import * as React from "react";
import { navigate } from "~/router";
import { Overlay, SideModal, SideModalContent } from "~/common/layout/Modals";
import Head from "~/common/layout/Head";
import ProductSegmentForm from "../../components/products/ProductSegmentForm";
import { useCreateProductGroup } from "~/apps/pos/apis/productGroups";
import { ProductSegmentReq } from "~/apps/pos/models";

const ProductGroupCreatePopup = () => {
  const { mutate: onCreate, error, isLoading } = useCreateProductGroup();

  const handleClose = () => {
    navigate("pos.admin.products.groups");
  };

  const handleSubmit = (data: ProductSegmentReq) => {
    onCreate(data, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const initialValues = {
    name: "",
  };

  return (
    <Overlay onClick={handleClose} isLoading={isLoading}>
      <SideModal>
        <Head headTitle={"New group"} />
        <SideModalContent>
          <ProductSegmentForm
            initialValues={initialValues}
            error={error?.message || error?.errorMessage || ""}
            onSubmit={handleSubmit}
            onClose={handleClose}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};

export default ProductGroupCreatePopup;
